import React from 'react';

type Props = {
  fill: string;
  stroke: string;
};

function Close({ fill, stroke }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.3 30.3">
      <defs>
        <style>
          {`
          .cls-1 { 
            fill: ${fill};
            stroke: ${stroke};
            stroke-miterlimit: 10;
            stroke-width: 0.5px;
          `}
        </style>
      </defs>
      <path
        className="cls-1"
        d="M15.1 30.1a15 15 0 1 1 10.6-4.4h0A14.9 14.9 0 0 1 15.1 30.1Zm0-28a13 13 0 1 0 9.2 22.2h0A13 13 0 0 0 15.1 2.1Z"
      />
      <polygon
        className="cls-1"
        points="22.9 8.8 21.5 7.4 15.1 13.7 8.8 7.4 7.3 8.8 13.7 15.1 7.3 21.5 8.8 22.9 15.1 16.5 21.5 22.9 22.9 21.5 16.5 15.1 22.9 8.8"
      />
    </svg>
  );
}

export default Close;
